
var stateManager = require('../state/stateManager.js');
var stringUtil = require('../string/stringUtil.js');
var commonUtility = require('../domain/commonUtility.js');
var dateUtil = require('../dateUtil/dateUtil.js');
var businessDateUtil = require('../dateUtil/businessDateUtil.js');
var guidUtil = require('../guid/guidUtil.js');
var constants = require('../domain/constants.js');
var accountsUtils = require('../domain/accountsUtils');
var staffUtility = require('./staff/staffUtility.js');
var terminalUtility = require('../domain/terminalUtility.js');

module.exports.getLoadedFloatSession = function()
{
    return stateManager.getStore().getState().cashFloatPayload;
}

module.exports.isCashFloatSessionLoaded = function()
{
    return this.getLoadedFloatSession() != null;
}

module.exports.isCashFloatSessionOpened = function()
{
    if (!this.isCashFloatSessionLoaded())
        return false;

    return stringUtil.isStringNullOrEmpty(this.getLoadedFloatSession().endDateTime);
}

module.exports.isCashFloatSessionClosed = function()
{
    return !this.isCashFloatSessionOpened();
}

module.exports.isCashFloatSessionExpired = function()
{
    if (!this.isCashFloatSessionLoaded() || !this.isCashFloatSessionOpened())
        return false;

    let todaysBusinessDate = businessDateUtil.getTodayBusinessDate();
    let sessionBusinessDate = businessDateUtil.getPropertyBusinessDateFromUtcDateTime(this.getLoadedFloatSession().startDateTime);
    return !dateUtil.isSame(todaysBusinessDate, sessionBusinessDate);
}


module.exports.isCashFloatSessionClosedOrExpired = function()
{
    return this.isCashFloatSessionClosed() || this.isCashFloatSessionExpired();
}

module.exports.getActiveFloatSession = function()
{
    if (!this.isCashFloatSessionLoaded() || this.isCashFloatSessionClosedOrExpired())
        return null;

    return this.getLoadedFloatSession();
}

module.exports.getActiveFloatSessionId = function()
{
    var activeFloatSession = this.getActiveFloatSession();
    if (activeFloatSession == null)
        return null;

    return activeFloatSession.id;
}


module.exports.getFloatSessionSummary = function(sessionReport)
{
    var result = {};
    result.availableCash = 0.0;
    result.openingBalance = 0.0;
    result.totalExpenses = 0.0;
    result.netChangePayment = 0.0;
    result.totalCashIn = 0.0;
    result.totalCashOut = 0.0;

    if (this.getLoadedFloatSession() == null)
        return result;


    this.getLoadedFloatSession().journals.forEach (journal =>
    {
        if (journal.isVoided)
            return;

        if (journal.type == constants.floatManagementJournalEntryType.Withdraw)
        {
            result.totalCashOut = result.totalCashOut + journal.amount;

            if (journal.subType == constants.floatManagementJournalEntrySubType.Expense)
            {
                result.totalExpenses = result.totalExpenses + journal.amount;
            }
            else if (journal.subType == constants.floatManagementJournalEntrySubType.ChangeGiven)
            {
                result.netChangePayment = result.netChangePayment + journal.amount;
            }
        }
            
        if (journal.type == constants.floatManagementJournalEntryType.Deposit)
        {
            result.totalCashIn = result.totalCashIn + journal.amount;

            if(journal.subType == constants.floatManagementJournalEntrySubType.OpeningBalance)
            {
                result.openingBalance = result.openingBalance + journal.amount;
            }

            else if(journal.subType == constants.floatManagementJournalEntrySubType.ChangeReturned)
            {
                result.netChangePayment = result.netChangePayment - journal.amount;
            }
        }
    });

    if (sessionReport != null && sessionReport.sales != null)
    {
        sessionReport.sales.forEach (sale =>
            {
                if (sale.paymentMethod == constants.PaymentMethodCash)
                {
                    result.totalCashIn = result.totalCashIn + sale.amount;
                }
            })
    }

    if (sessionReport != null && sessionReport.refunds != null)
    {
        sessionReport.refunds.forEach (refund =>
            {
                if (refund.paymentMethod == constants.PaymentMethodCash)
                {
                    result.totalCashOut = result.totalCashOut + refund.amount;
                }
            })
    }

    result.availableCash = result.totalCashIn - result.totalCashOut;
    return result;
}


module.exports.createNewSession = function()
{
    var session = {};
    session.id = guidUtil.generateGuid();
    session.propertyId = commonUtility.getProperty().id;
    session.floatIdentifier = terminalUtility.getTerminalFloatIdentifier();
    session.startedBy = staffUtility.getLoginStaff().id;
    session.startDateTime = dateUtil.getNow();
    session.journals = [];

    return session;
}

module.exports.createJournal = function(sessionId, type, subType, subTypeReferenceId, amount)
{
    var journal = {};
    journal.id = guidUtil.generateGuid();
    journal.floatSessionId = sessionId;
    journal.type = type;
    journal.subType = subType;

    journal.subTypeReferenceId = subTypeReferenceId;    //Id for reference table based on sub-type  
    journal.amount = amount;
    journal.createdByStaffId = staffUtility.getLoginStaff().id;
    journal.creationDateTime = dateUtil.getNow();
    journal.isVoided = false;

    return journal;
}

module.exports.voidJournal = function(journal)
{
    journal.isVoided = true;
    journal.voidedBy = staffUtility.getLoginStaff().id;
    journal.voidedDateTime = dateUtil.getNow();
    return journal;
}

module.exports.closeSession = function(session)
{
    session.endedBy = staffUtility.getLoginStaff().id;
    session.endDateTime = dateUtil.getNow();
    return session;
}

module.exports.getExpenseCategoryIdOfFloatSession = function()
{
    var floatConfiguration = commonUtility.getPropertyFloatConfiguration();
    if (floatConfiguration == null || floatConfiguration.categoryId == null)
        return null;

    return floatConfiguration.categoryId;
}

module.exports.getExpenseSubCategoriesOfFloatSession = function()
{
    var categoryId = this.getExpenseCategoryIdOfFloatSession();
    return accountsUtils.getSubCategories(categoryId);
}